import { render, staticRenderFns } from "./AddBulk.vue?vue&type=template&id=05092768"
import script from "./AddBulk.vue?vue&type=script&lang=js"
export * from "./AddBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports